// Resolve the page-level scroll surface's scrollable viewport for an element
// inside it — so an embedded DataTable scrolls and sticks against the PAGE
// (Overview / Endpoint / lens bodies each declare a `[data-content-scroll]`
// ScrollArea) instead of pinning a header over an interior scroll box. Mirrors
// the per-panel resolvers in TraceLogPanel / CommandLogPanel; shared so new
// embedded tables don't re-roll the same walk.
export function findContentScrollRoot(element) {
  if (!element) return null;
  const host =
    element.closest("[data-content-scroll]") ||
    element.closest("[data-endpoint-content-scroll]");
  if (!host) return null;
  return (
    host.querySelector("[data-overlayscrollbars-viewport]") ||
    host.querySelector(".os-viewport") ||
    host
  );
}
